"use client";

import { Bot } from "lucide-react";

interface SystemBlockProps {
  body: string | null;
  createdAt: string;
}

export function SystemBlock({ body, createdAt }: SystemBlockProps) {
  return (
    <div className="rounded-lg border border-gray-100 border-l-4 border-l-gray-400 bg-white p-3">
      <div className="flex items-start gap-2">
        <div className="rounded-full bg-gray-100 p-1.5 text-gray-500">
          <Bot className="h-3.5 w-3.5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <p className="text-xs font-medium text-gray-500">System</p>
            <span className="text-[10px] text-gray-400">
              {new Date(createdAt).toLocaleTimeString("en-ZA", { hour: "2-digit", minute: "2-digit" })}
            </span>
          </div>
          {body && <p className="mt-1 text-xs italic text-gray-500 break-words">{body}</p>}
        </div>
      </div>
    </div>
  );
}
